const config = {
  apiGateway: {
    REGION: 'us-west-2',
    INTERNAL_API_URL: 'https://7pn2zj7wp3.execute-api.us-west-2.amazonaws.com/prod',
    TARGET_API_URL: 'https://9bd68ip28d.execute-api.us-west-2.amazonaws.com/api',
    TEAMS_APP_URL: 'https://teams.staging.evolution.forwoodsafety.com/teams',
    QS_DASHBOARD_URL: '',
    CLIENT_TIMEZONE: 'America/Sao_Paulo'
  },
  reactApp: {
    VERSION: 'targets-1.12.2',
    HOSTNAME: 'https://targets.staging.evolution.forwoodsafety.com'
  }
};

export default config;